var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"primary-background",attrs:{"wrapper-class":"container","close-on-click":true},scopedSlots:_vm._u([{key:"brand",fn:function(){return [_c('a',{staticClass:"is-relative",staticStyle:{"padding":"0"},attrs:{"href":"https://www.uzh.ch/"}},[_c('div',{staticClass:"is-relative"},[_c('figure',[_c('img',{staticStyle:{"height":"5.5rem","width":"12rem"},attrs:{"src":require("@/assets/logos/logo-uzh.svg")},on:{"load":function($event){_vm.isReady = true}}})])])])]},proxy:true},{key:"end",fn:function(){return [_c('b-navbar-item',{staticClass:"has-text-weight-bold nav-link",attrs:{"tag":"router-link","to":{
        name: 'Dynamic',
        params: {
          edition: 'iurisprudentia',
          componentType: 'about',
          lang: _vm.locale
        },
      }}},[_vm._v("\n      "+_vm._s(_vm.$t("navTitles.about"))+"\n    ")]),_c('b-navbar-item',{staticClass:"has-text-weight-bold nav-link",attrs:{"tag":"router-link","to":{
        name: 'Newsletter',
        params: {
          lang: _vm.locale
        }
      }}},[_vm._v("\n      "+_vm._s(_vm.$t("navTitles.news"))+"\n    ")]),_c('b-navbar-item',{staticClass:"has-text-weight-bold nav-link",attrs:{"tag":"router-link","to":{
        name: 'Dynamic',
        params: {
          edition: 'iurisprudentia',
          componentType: 'impressum',
          lang: _vm.locale
        },
      }}},[_vm._v("\n      "+_vm._s(_vm.$t("navTitles.imprint"))+"\n    ")]),_c('b-navbar-item',{staticClass:"has-text-weight-bold nav-link",attrs:{"tag":"router-link","to":{
        name: 'Dynamic',
        params: {
          edition: 'iurisprudentia',
          componentType: 'privacy',
          lang: _vm.locale
        },
      }}},[_vm._v("\n      "+_vm._s(_vm.$t("navTitles.privacy"))+"\n    ")]),_c('LocaleSwitcher')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }